﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSession = void 0;
class AuthSession {
}
exports.AuthSession = AuthSession;
//# sourceMappingURL=AuthSession.js.map